import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_orders_aggregated_tasksService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { orderIds: number[], operationCodeIds?: number[], statusIds?: number[] }): 
  Promise<{ result: { ActualPackagedAmount?: number, ExpectedPackagedAmount?: number, ActualAmount?: number, ExpectedAmount?: number, RecordCount?: number, OperationCodeId?: number, StatusId?: number, OrderId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderIds)) {
      missingRequiredInParams.push('\'orderIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_orders_aggregated_tasks/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { orderIds: number[], operationCodeIds?: number[], statusIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { ActualPackagedAmount?: number, ExpectedPackagedAmount?: number, ActualAmount?: number, ExpectedAmount?: number, RecordCount?: number, OperationCodeId?: number, StatusId?: number, OrderId?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderIds)) {
      missingRequiredInParams.push('\'orderIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_orders_aggregated_tasks/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { orderIds: number[], operationCodeIds?: number[], statusIds?: number[], $keys: { OperationCodeId?: number, StatusId?: number, OrderId?: number }[] }): 
  Promise<{ result: { ActualPackagedAmount?: number, ExpectedPackagedAmount?: number, ActualAmount?: number, ExpectedAmount?: number, RecordCount?: number, OperationCodeId?: number, StatusId?: number, OrderId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderIds)) {
      missingRequiredInParams.push('\'orderIds\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_orders_aggregated_tasks/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      orderIds: number[], operationCodeIds?: number[], statusIds?: number[]    }) {
        if(isNil(inParams.orderIds)) {
          return true; 
        }
      return false;
    }
}
